export const localStorageEnums = {
    CompanyInfo: "CompanyInfo"
}
